import pathUtils from './pathUtils';
import webUtils from './webUtils';

const wcmUtils = {
  convertLanguage: (lang) => {
    switch (lang) {
      case 'ja':
        return 'jpn';
      case 'en':
      default:
        return 'enu';
    }
  },
  getSdkUrl: () => {
    if (pathUtils.isEyewear()) {
      return webUtils.isDemoEnv() || webUtils.isDevEnv()
        ? 'https://plugins-media.makeupar.com/smb-demo/v3.7/sdk.js?apiKey=SMB-Ojo6MTQ4ODA='
        : 'https://plugins-media.makeupar.com/smb/v3.7/sdk.js?apiKey=SMB-Ojo6NDQ0NDA=';
    }
    return 'https://plugins-media.makeupar.com/smb/v3.6/sdk.js?apiKey=SMB-Ojo6NDMzNzE=';
  },
  loadWebModule: () => {
    return new Promise((resolve) => {
      if (window.YMK) {
        return resolve();
      }

      const sdkUrl = wcmUtils.getSdkUrl();
      if (wcmUtils.isScriptAppended(sdkUrl)) {
        return resolve()
      }

      const script = document.createElement('script');
      script.src = sdkUrl;
      script.async = true;
      script.onload = () => resolve();
      document.body.appendChild(script);
    });
  },
  isScriptAppended: (sdkUrl) => {
    for (const element of document.getElementsByTagName('script')) {
      if (element.src === sdkUrl) {
        return true;
      }
    }
    return false;
  },
};

export default wcmUtils;
